import { Directive, input } from '@angular/core';
import { Asset } from 'src/app/common/models/ai-reports/shared/assets'; 

@Directive()
export abstract class AbstractAssetComponent<TAsset extends Asset> {
  readonly asset = input.required<TAsset>();
  readonly mode = input<'thumbnail' | 'view' | 'details'>('view');
}